import { Modal, Box, Button, CircularProgress } from "@mui/material";
import { DeleteDeviceModalProps } from "./types";
import { useCallback, useContext, useState } from "react";
import { useBus, useListener } from "react-bus";
import DeviceApi from "../../../../api/device";
import { AppContext, IAppContext } from "../../../../Contexts/AppContext";

const style = {
	position: "absolute" as "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	textAlign: "center",
	p: 4,
};

export default function DeleteDeviceModal(props: DeleteDeviceModalProps) {
	const { deviceToDelete, reactOnDelete = () => {} } = props;
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);

	const bus = useBus();

	const handleOpen = useCallback(() => setOpen(true), []);
	const handleClose = () => setOpen(false);
	const { snackBar, setSnackBar } = useContext(AppContext) as IAppContext;

	const deleteOperation = useCallback(async () => {
		try {
			setLoading(true);
			const deletedDevice = await DeviceApi.deleteDevice({
				token: localStorage.getItem("accessToken") || "",
				deviceId: deviceToDelete?.id || "",
			});

			bus.emit("reloadDevicesScreenData");
			handleClose();
			setSnackBar({
				...snackBar,
				open: true,
				message: "Carga eliminada",
				autoHideDuration: 6000,
				severity: "success",
			});

			if (reactOnDelete) {
				reactOnDelete(deletedDevice);
			}
		} catch (error: any) {
			console.error(error);
			setSnackBar({
				...snackBar,
				open: true,
				message: "Error al eliminar la carga",
				autoHideDuration: 6000,
				severity: "error",
			});
		} finally {
			setLoading(false);
		}
	}, [deviceToDelete]);

	useListener("openDeleteDeviceModal", handleOpen);

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'>
			<Box sx={style}>
				<h2 id='modal-modal-title'>
					{loading ? "Eliminando Carga" : "Eliminar Carga"}
				</h2>
				{loading ? (
					<CircularProgress size={35} />
				) : (
					<>
						<p id='modal-modal-description'>
							Esta seguro que desea eliminar la carga {deviceToDelete?.deviceId}{" "}
							?
						</p>
						<p id='modal-modal-description-secondary'>
							Direccion de la carga: {deviceToDelete?.address}
						</p>

						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								marginTop: 2,
							}}>
							<Button
								variant='contained'
								color='error'
								onClick={() => {
									deleteOperation();
								}}>
								Eliminar
							</Button>
							<Button variant='contained' color='primary' onClick={handleClose}>
								Cancelar
							</Button>
						</Box>
					</>
				)}
			</Box>
		</Modal>
	);
}
